import React from 'react';
import WebSocketDebugger from '@/components/WebSocketDebugger';

// Only show debugger on localhost
const isLocalhost = typeof window !== 'undefined' && 
  (window.location.hostname === 'localhost' || 
   window.location.hostname === '127.0.0.1' || 
   window.location.hostname === '0.0.0.0');

interface WebSocketDebuggerProviderProps {
  children: React.ReactNode;
}

const WebSocketDebuggerProvider: React.FC<WebSocketDebuggerProviderProps> = ({ children }) => {
  // Only show debugger on localhost
  return (
    <>
      {children}
      {isLocalhost && <WebSocketDebugger />}
    </>
  );
};

export default WebSocketDebuggerProvider; 